import fetch from 'auth/FetchInterceptor'
import { API_BASE_URL } from 'configs/AppConfig'
import axios from 'axios';

const AuthService = {}

// Login
AuthService.login = function (data) {
	return fetch({
		url: API_BASE_URL + '/auth/login',
		method: 'post',
		data: data
	})
}

// Register
AuthService.register = function (data) {
	return fetch({
		url: API_BASE_URL + '/auth/register',
		method: 'post',
		data: data
	})
}

// Refresh token - use plain axios to avoid interceptor loops
AuthService.refreshToken = async function (refreshToken) {
	try {
		const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
			refreshToken
		});
		return response.data;
	} catch (error) {
		throw error;
	}
}

// Get current user
AuthService.getCurrentUser = function () {
	return fetch({
		url: API_BASE_URL + '/auth/me',
		method: 'get'
	})
}

// Logout
AuthService.logout = function (refreshToken) {
	return fetch({
		url: API_BASE_URL + '/auth/logout',
		method: 'post',
		data: { refreshToken }
	})
}

// Logout from all devices
AuthService.logoutAll = function () {
	return fetch({
		url: API_BASE_URL + '/auth/logout-all',
		method: 'post'
	})
}

// Change password
AuthService.changePassword = function (data) {
	return fetch({
		url: API_BASE_URL + '/auth/change-password',
		method: 'put',
		data: data
	})
}

// Set password (for temporary password change)
AuthService.setPassword = function (data) {
	return fetch({
		url: API_BASE_URL + '/auth/set-password',
		method: 'put',
		data: data
	})
}

export default AuthService;
